import React, { useState } from 'react';
import { FaArrowAltCircleRight } from "react-icons/fa";
import './StepOneConfirmQuantity.css';

function StepOneConfirmQuantity({ defaultQuantity = 1, onQuantityConfirmed, onContinue }) {
  const [localQuantity, setLocalQuantity] = useState(String(defaultQuantity));
  const [error, setError] = useState('');

  const handleChange = (e) => {
    const val = e.target.value;

    if (val === '') {
      setLocalQuantity('');
      setError('');
      return;
    }
    const parsed = parseInt(val, 10);

    if (!Number.isNaN(parsed)) {
      setLocalQuantity(val);
      setError('');
    } else {
      setError('Please enter numbers only.');
    }
  };

  const handleContinue = () => {
    const parsed = parseInt(localQuantity, 10);
    if (!localQuantity || Number.isNaN(parsed) || parsed < 1) {
      setError('Please enter a valid quantity (minimum 1).');
      return;
    }
    setError('');
    onQuantityConfirmed(parsed);
    onContinue();
  };

  return (
    <div className="StepOneContainer" style={{ }}>
      <div className="StepOneStep">Step 1.</div>
      <div className="StepOneTitle">Confirm Quantity</div>
      <label className="StepOneLabel">
        Quantity:
        <input
          type="number"
          inputMode="tel"
          step="1"
          value={localQuantity}
          onChange={handleChange}
          className="StepOneInput"
        />
      <button onClick={handleContinue} className="StepOneButton">
        Continue <div className="StepOneButtonIcon"><FaArrowAltCircleRight /></div>
      </button>
      </label>

      {error && (
        <div className="StepOneError">
          {error}
        </div>
      )}

    </div>
  );
}

export default StepOneConfirmQuantity;